<template>
  <nav class="tb-nav" aria-label="Navegación del portal">
    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      class="tb-nav__item"
      :class="{ 'tb-nav__item--active': item.match(route.path) }"
    >
      <span class="mdi tb-nav__icon" :class="item.icon"></span>
      <span class="tb-nav__label">{{ item.short }}</span>
    </router-link>
  </nav>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/services/authStore'
import { tenantNavItems, tenantAccountItem } from './tenantNav'

const route = useRoute()
const { state } = useAuthStore()
const items = computed(() => [...tenantNavItems(state.user?.sections, state.user?.contractCount), tenantAccountItem])
</script>

<style scoped>
.tb-nav { display: none; }

@media (max-width: 768px) {
  .tb-nav {
    display: flex; position: fixed; left: 0; right: 0; bottom: 0; z-index: 1000;
    height: calc(56px + env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom);
    background: #1e3a5f; border-top: 1px solid rgba(255, 255, 255, 0.08);
  }
  .tb-nav__item {
    flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 2px;
    color: rgba(255, 255, 255, 0.6); text-decoration: none;
  }
  .tb-nav__item--active { color: #fff; }
  .tb-nav__icon { font-size: 22px; line-height: 1; }
  .tb-nav__label { font: 500 10px Inter, sans-serif; }
}
</style>